import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HomeComponent} from './pages/home/home.component';
import {AboutUsComponent} from './pages/about-us/about-us.component';
import {DownloadsComponent} from './pages/downloads/downloads.component';
import {ProductsComponent} from './pages/products/products.component';
import {ContactComponent} from './pages/contact/contact.component';
import {routes} from './model/constant';
import {ServicesComponent} from './pages/services/services.component';


const navs: Routes = [
  {path: routes.home, component: HomeComponent},
  {path: routes.about, component: AboutUsComponent},
  {path: routes.catalogue, component: DownloadsComponent},
  {path: routes.products, component: ProductsComponent},
  {path: routes.contact, component: ContactComponent},
  {path: '', redirectTo: 'home', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(navs)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
